import { FC, memo, useCallback, useEffect, useState } from 'react';
import FlowDescription from '../../FlowDescription';
import { Field } from '../../../types';
import PvAreaSelector from './PvAreaSelector';

const PvAreaSource: FC<Field> = ({ label }) => {
  return (
    <div className="flex flex-col gap-6">
      <FlowDescription componenet="accordion">
        Nutzen Sie die Zeichen-Werkzeuge um geplante und bestehende PV-Anlagen einzuzeichnen.
      </FlowDescription>

      {/* <div className="px-6 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark"> */}
      <PvAreaSelector />
      {/* </div> */}
    </div>
  );
};

export default memo(PvAreaSource);
